import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { get } from "lodash";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import {
  CONSIGNMENT_REFERENCE,
  VIRTUALLY_RECEIVING
} from "MODULES/Receiving/constants";
import {
  CAGE,
  DOM,
  NET_HEIGHT,
  NET_LENGTH,
  NET_WEIGHT,
  NET_WEIGHT_OZ,
  NET_WEIGHT_UNIT,
  NET_WIDTH
} from "MODULES/parts/constants";
import {
  AS_REMOVED,
  CAAC,
  CONDITION,
  EASA,
  FAA,
  LOCATION,
  OTHER_TAG_TYPE,
  PART_ID,
  TAG_DATE,
  TAGGED_BY,
  TCCA,
  TRACE_TYPE,
  TRACED_TO,
  WARE_HOUSE_ID
} from "MODULES/inventories/constants";
import { AWB_NUMBER, ID } from "APP_ROOT/constants";
import { USER } from "MODULES/users/constants";
import { LOCATION_ID } from "MODULES/Locations/constants";
import { EXPECTED_SERIAL_NUMBER } from "MODULES/PurchaseOrders/constants";
import { isModTo } from "MODULES/Receiving/helpers";
import { OTHER } from "MODULES/shared/constants";
import Form from "./Form";
import { RO_ITEM, SO_ITEM } from "../../../Orders/shared/constants";
import { REPAIR_EVALUATION_APPROVED } from "../../../RepairOrders/constants";

const InventoryTransferOrder = "InventoryTransferOrder";
export const NSN_ABBREV = "NSN";

class Create extends React.Component {
  // ADD more types as we continue to add modules
  render() {
    const mapType = {
      consignment_line_item: "ConsignmentLineItem",
      rma: "Rma",
      lot: "Lot",
      lot_line_item: "LotLineItem",
      managed_repair_order_line_item: "ManagedRepairOrderLineItem",
      purchase_order_line_item: "PurchaseOrderLineItem",
      repair_order_line_item: "RepairOrderLineItem",
      sales_order_line_item: "SalesOrderLineItem",
      inventory_transfer_order: InventoryTransferOrder
    };

    const receivingType = {
      consignment_line_item: "consignment",
      sales_order_line_item: "so",
      lot: "lot",
      lot_line_item: "lot_line_item",
      managed_repair_order_line_item: "mro",
      purchase_order_line_item: "po",
      repair_order_line_item: "ro",
      inventory_transfer_order: "transfer"
    };
    const {
      open,
      close,
      currentUser,
      receivingRecord,
      removeItem,
      virtual
    } = this.props;

    const requiredKeys = [
      AWB_NUMBER,
      CAAC,
      CONDITION,
      CONSIGNMENT_REFERENCE,
      DOM,
      EASA,
      EXPECTED_SERIAL_NUMBER,
      FAA,
      LOCATION,
      TAG_DATE,
      TAGGED_BY,
      OTHER,
      OTHER_TAG_TYPE,
      PART_ID,
      TCCA,
      TRACE_TYPE,
      TRACED_TO,
      WARE_HOUSE_ID,
      VIRTUALLY_RECEIVING
    ];
    const buildInitialValues = () =>
      receivingRecord &&
      requiredKeys.reduce((acc, item) => {
        acc[item] = receivingRecord[item];
        return acc;
      }, {});

    const buildNetWeightAndDims = () =>
      [
        CAGE,
        NET_WEIGHT,
        NET_WEIGHT_OZ,
        NET_LENGTH,
        NET_WIDTH,
        NET_HEIGHT
      ].reduce(
        (acc, item) => {
          acc[item] =
            get(receivingRecord, item) || get(receivingRecord, `part.${item}`);
          return acc;
        },
        {
          [NET_WEIGHT_UNIT]:
            get(receivingRecord, `part.${NET_WEIGHT_UNIT}`) || "lb"
        }
      );

    const buildRecordInitialValues = () => {
      if (
        receivingRecord &&
        receivingRecord.type === RO_ITEM &&
        receivingRecord.approval_status === REPAIR_EVALUATION_APPROVED
      ) {
        return {
          tagged_by: get(receivingRecord, "company.name"),
          tagged_by_id: get(receivingRecord, "company.id")
        };
      }

      if (receivingRecord && receivingRecord.type === SO_ITEM) {
        return {
          tagged_by: undefined,
          tagged_by_id: undefined,
          tag_date: undefined
        };
      }

      return {};
    };

    const expectedQuantity =
      receivingRecord &&
      receivingRecord.quantity - receivingRecord.quantity_received;

    const getSerialNumber = () => {
      if (receivingRecord && receivingRecord.type === SO_ITEM) {
        return "";
      }
      if (expectedQuantity === 1) {
        return receivingRecord.serial_number;
      }
      return NSN_ABBREV;
    };

    const initialValues = {
      attachments: (receivingRecord && receivingRecord.attachments) || [],
      dom: get(receivingRecord, DOM) || get(receivingRecord, "line_item.dom"),
      store_location_id: currentUser.getIn([LOCATION, ID]),
      receiving_type: receivingRecord && receivingType[receivingRecord.type],
      reference_record_line_item_id: receivingRecord && receivingRecord.id,
      quantity: expectedQuantity,
      reference_record_line_item_type:
        receivingRecord && mapType[receivingRecord.type],
      part: null,
      serial_number: getSerialNumber(),
      ...buildInitialValues(),
      ...buildNetWeightAndDims(),
      part_id: isModTo(receivingRecord)
        ? receivingRecord.mod_to_id
        : receivingRecord && receivingRecord.part_id,
      condition:
        receivingRecord && receivingRecord.type === SO_ITEM
          ? AS_REMOVED
          : get(receivingRecord, CONDITION),
      consignor_percentage: 0,
      received_virtually: virtual,
      tagged_by_existing_company: true,
      location: get(receivingRecord, VIRTUALLY_RECEIVING)
        ? "Dropship"
        : get(receivingRecord, LOCATION) ||
          get(receivingRecord, "line_item.expected_location"),
      shipped_properly: get(receivingRecord, "shipped_properly", false),
      vendor_packing_list_included: get(
        receivingRecord,
        "vendor_packing_list_included",
        false
      ),
      packing_list_and_tags_match: get(
        receivingRecord,
        "packing_list_and_tags_match",
        false
      ),
      passed_damage_inspection: get(
        receivingRecord,
        "passed_damage_inspection",
        false
      ),
      release_certificate_included: get(
        receivingRecord,
        "release_certificate_included",
        false
      ),
      ...buildRecordInitialValues(),
      tagged_by_id:
        get(receivingRecord, TAGGED_BY) ||
        get(receivingRecord, "line_item.tagged_by"),
      ware_house_id:
        get(receivingRecord, WARE_HOUSE_ID) ||
        get(receivingRecord, "line_item.expected_ware_house_id"),
      internal_note: get(receivingRecord, "line_item.internal_note", "")
    };

    return (
      <div>
        <Modal open={open} close={close} dialogClass="modal-lg">
          <Header>
            <Close close={close} />
            <h4 className="modal-title">
              Receiving Checklist {get(receivingRecord, "reference_number")}
            </h4>
          </Header>
          <Form
            close={close}
            removeItem={removeItem}
            initialValues={
              receivingRecord
                ? initialValues
                : {
                    store_location_id: currentUser.get(LOCATION_ID),
                    quantity: 1
                  }
            }
            selectedBuyer={currentUser.toJS()}
            receivingRecord={receivingRecord}
            lockFields={
              receivingRecord &&
              mapType[receivingRecord.type] === InventoryTransferOrder
            }
            virtualReceiving={
              virtual &&
              receivingRecord &&
              mapType[receivingRecord.type] !== InventoryTransferOrder
            }
            enableReinitialize
          />
        </Modal>
      </div>
    );
  }
}

Create.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  currentUser: PropTypes.instanceOf(Map),
  receivingRecord: PropTypes.shape({}),
  removeItem: PropTypes.func.isRequired,
  virtual: PropTypes.bool.isRequired
};

export default connect(state => ({
  currentUser: state.session.get(USER)
}))(Create);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Dashboard/Create/Create.jsx